'use client';

import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useAppCache } from './Hooks/useAppCache';

const Card = styled.div`
  max-width: 28rem;
  margin: 0 auto;
  padding: 1.5rem;
  background: #fff;
  border: 1px solid #e4e4e7;
  border-radius: 0.75rem;
  font-family: system-ui, sans-serif;
  font-size: 0.875rem;
`;

const Row = styled.div<{ $indent?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  ${({ $indent }) => $indent && 'padding-left: 1rem; color: #71717a;'}
`;

/**
 * This is a debug component who shouldn't be used for end users. 
 * @returns 
 */
export default function CacheDashboard() {
  const [mounted, setMounted] = useState(false);
  const { cacheSize, buckets, appState, contentStatus, syncChannels, isClearing, handleClearCache } = useAppCache();

  useEffect(() => { setMounted(true); }, []);

  if (!mounted) return <Card>Loading...</Card>;

  return (
    <Card>
      <Row><span>Cache Size</span><code>{cacheSize}</code></Row>

      {buckets.map((bucket) => (
        <Row key={bucket.name} $indent>
          <span>↳ {bucket.name} ({bucket.count} items)</span>
          <code>{bucket.size}</code>
        </Row>
      ))}

      <Row><span>App Cache</span><span>{appState}</span></Row>
      <Row><span>Data Sync</span><span>{contentStatus}</span></Row>

      {Object.values(syncChannels).map((progress) => (
        <Row key={progress.channel} $indent>
          <span>↳ {progress.cacheName}</span>
          <code>{progress.completed} / {progress.total}</code>
        </Row>
      ))}

      <hr style={{ margin: '1rem 0', border: '0', borderTop: '1px solid #e4e4e7' }} />

      <button
        onClick={handleClearCache}
        disabled={isClearing}
        style={{ width: '100%', padding: '0.5rem', cursor: isClearing ? 'not-allowed' : 'pointer' }}
      >
        {isClearing ? 'Clearing...' : 'Erase All Local Cache'}
      </button>
    </Card>
  );
}